/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    PlaylistMilestoneNotificationActionData,
    instanceOfPlaylistMilestoneNotificationActionData,
    PlaylistMilestoneNotificationActionDataFromJSON,
    PlaylistMilestoneNotificationActionDataFromJSONTyped,
    PlaylistMilestoneNotificationActionDataToJSON,
} from './PlaylistMilestoneNotificationActionData';
import {
    TrackMilestoneNotificationActionData,
    instanceOfTrackMilestoneNotificationActionData,
    TrackMilestoneNotificationActionDataFromJSON,
    TrackMilestoneNotificationActionDataFromJSONTyped,
    TrackMilestoneNotificationActionDataToJSON,
} from './TrackMilestoneNotificationActionData';
import {
    UserMilestoneNotificationActionData,
    instanceOfUserMilestoneNotificationActionData,
    UserMilestoneNotificationActionDataFromJSON,
    UserMilestoneNotificationActionDataFromJSONTyped,
    UserMilestoneNotificationActionDataToJSON,
} from './UserMilestoneNotificationActionData';

/**
 * @type MilestoneNotificationActionData
 * 
 * @export
 */
export type MilestoneNotificationActionData = PlaylistMilestoneNotificationActionData | TrackMilestoneNotificationActionData | UserMilestoneNotificationActionData;

export function MilestoneNotificationActionDataFromJSON(json: any): MilestoneNotificationActionData {
    return MilestoneNotificationActionDataFromJSONTyped(json, false);
}

export function MilestoneNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...PlaylistMilestoneNotificationActionDataFromJSONTyped(json, true), ...TrackMilestoneNotificationActionDataFromJSONTyped(json, true), ...UserMilestoneNotificationActionDataFromJSONTyped(json, true) };
}

export function MilestoneNotificationActionDataToJSON(value?: MilestoneNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPlaylistMilestoneNotificationActionData(value)) {
        return PlaylistMilestoneNotificationActionDataToJSON(value as PlaylistMilestoneNotificationActionData);
    }
    if (instanceOfTrackMilestoneNotificationActionData(value)) {
        return TrackMilestoneNotificationActionDataToJSON(value as TrackMilestoneNotificationActionData);
    }
    if (instanceOfUserMilestoneNotificationActionData(value)) {
        return UserMilestoneNotificationActionDataToJSON(value as UserMilestoneNotificationActionData);
    }

    return {};
}

